import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {
  ListingCardComponent,
  ListingSkeletonComponent,
  LocationPageTitleComponent,
} from '@out-web/components';
import { IListing, ListingsService } from '@out-web/core';

@Component({
  selector: 'out-location-listings',
  imports: [
    ListingCardComponent,
    CommonModule,
    ListingSkeletonComponent,
    LocationPageTitleComponent,
    RouterLink,
  ],
  templateUrl: './location-listings.component.html',
  styleUrl: './location-listings.component.css',
})
export class LocationListingsComponent implements OnInit {
  placeholderSkeletons = Array(6).fill(0);
  listings: IListing[] = [];
  loading = false;
  error: string | null = null;
  location = '';
  currentRoute = '';

  constructor(
    private meta: Meta,
    private title: Title,
    private route: ActivatedRoute,
    private listingsService: ListingsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.setRouteParams();
  }

  private setRouteParams() {
    this.route.paramMap.subscribe((params) => {
      const location = params.get('location');
      this.currentRoute = this.router.url;
      if (location) {
        this.updateMeta(location);
        this.fetchListings(location);
      }
    });
  }

  private updateMeta(location: string): void {
    const formatLocation = location.replace(/\b\w/g, (char) =>
      char.toUpperCase()
    );
    const pageTitle = this.currentRoute.includes('/used-tesla-for-sale')
      ? `Used Tesla for Sale in ${formatLocation} | Only Used Tesla`
      : this.currentRoute.includes('/sell-my-tesla')
      ? `Sell My Tesla in ${formatLocation} | Only Used Tesla`
      : `Used Tesla for Sale in ${formatLocation} | Only Used Tesla`;
    this.title.setTitle(pageTitle);
    this.meta.updateTag({
      name: 'description',
      content: `Find used Tesla vehicles for sale in ${formatLocation}. Only the best pre-owned Tesla models.`,
    });
  }

  private fetchListings(location: string): void {
    this.loading = true;
    this.error = null;

    const trimmedLocation = location
      .trim()
      .replace(/\b\w/g, (char) => char.toUpperCase());

    this.listingsService.fetchListingsByLocation(trimmedLocation)?.subscribe({
      next: (response) => {
        if (response && response.listings) {
          this.listings = response.listings;
          this.loading = false;
          this.location = trimmedLocation;
          
        } else {
          this.error = 'No listings found for the selected location.';
          console.log(this.error);
          this.loading = false;
        }
      },
      error: (err) => {
        this.error = 'Failed to load listings. Please try again later.';
        this.loading = false;
        console.log(err);
      },
    });
  }
}
